import { Injectable } from '@angular/core';
import {
  DaliService,
  IPageLoadModel,
  ITrackEventModel,
} from '@dali/tagger-ng8';

import { BUSINESS_CONST } from '../../constants/business.constants';
import { Changes, TagEvent, TagIdentifier } from '../../models/dali-tags.model';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { ParametersService } from '../parameters/parameters.service';
import { ChannelCommunicatorService } from '../communicator/channel-communicator/channel-communicator.service';
import { BioCatchService } from '../external/biocatch/biocatch.service';
import { FirmlyApprovedService } from '../firmly-approved/firmly-approved.service';
import { PAGEVIEW } from '../../constants/dali-fa-tc.constants';
import { EVENT } from '../../constants/dali.constants';
import { CHANNEL } from '../../constants/channel.constants';

// import { NavigationService } from '../navigation/navigation.service';

/**
 * Obtener el valor de una dependencia, en este caso, ésta clase es visible para toda la app
 *
 * *Obtain the valua of a dependency, in this case, this class is visible for the entire app*
 */
@Injectable({
  providedIn: 'root',
})

/**
 * Servicio para el envío de tags a Google analytics
 *
 * *Tagging service to send data to Google Analytics*
 */
export class TaggingService {
  environment = '';
  GTM_CODE = '';

  /**
   * Identificador del tag de la página
   *
   * *Page tag identifier*
   *
   * @type {TagIdentifier}
   * @access private
   */
  private tagsIdentifiers: TagIdentifier;

  /**
   * Nombre de la ruta del tag de analítica
   *
   * *Tags name path of analytics*
   *
   * @access              private
   * @type                { TagPathProduct }
   */
  // private tagsNamePath: TagPathProduct;

  productsType: any = {
    ORD: 'LD',
    TCR: 'TC',
    CRP: 'CR',
  };

  /**
   * Constructor del componente
   *
   * *Constructor of the component.*
   *
   * @param {AbreCuentasService}         daliService                 Injectable dali service.
   * @param {AbreCuentasService}         abreCuentasService          Injectable abreCuentasService service.
   * @param {NavigationService}          navigationService           Injectable navigationService service.
   * @param {ChannelCommunicatorService} channelCommunicatorService  Injectable channelCommunicatorService service.
   */
  constructor(
    private daliService: DaliService,
    private abreCuentasService: AbreCuentasService,
    private parameterService: ParametersService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private bioCatchService: BioCatchService,
    private firmlyApprovedService: FirmlyApprovedService,
  ) { }

  /**
   * Función de inicialización de la librería Dali
   *
   * *Initialization function for Dali library*
   *
   * @returns {Promise}
   */
  async initAnalytics(): Promise<any> {
    const abreCuentasConfigs = this.abreCuentasService.getAbreCuentasConfigs();
    const daliEnv = this.parameterService.getParameter('daliEnvProd');
    console.log('daliEnv', daliEnv);
    this.GTM_CODE = daliEnv
      ? this.abreCuentasService.getDataTagg().GTM_CODE_PROD
      : this.abreCuentasService.getDataTagg().GTM_CODE_DEV;
    const IS_RELEASE_ENV = daliEnv;
    const analyticsJsonURL = abreCuentasConfigs.analytics_json_url;

    return new Promise((resolve, reject) => {
      this.daliService
        .initAnalytics(this.GTM_CODE, IS_RELEASE_ENV, analyticsJsonURL)
        .then(res => {
          resolve(res);
        })
        .catch(err => reject(err));
    });
  }

  pageLoadtagg(page) {
    let changes: IPageLoadModel[] = [];

    if (this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}pageName`]) {
      changes.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW[
          `pv${page}pageName`
        ].path,
        value: `${this.channelCommunicatorService.getChannelId() === '141'
          ? this.abreCuentasService.getDataTagg().CHANNEL.superapp
          : this.abreCuentasService.getDataTagg().CHANNEL.homeBanking
          }:${this.abreCuentasService.getDataTagg().COUNTRY.co}:${this.abreCuentasService.getDataTagg().BUSINNESS.pf
          }:${this.abreCuentasService.getDataTagg().ENVIRONMENT.loggeado}:${this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}pageFamily`]
            .value
          }:${this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}subFamily`]
            .value
          }:${this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}pageAction`]
            .value
          }:${this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}pageName`]
            .value
          }`,
      });
    }
    if (this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}pageFamily`]) {
      changes.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW[
          `pv${page}pageFamily`
        ].path,
        value:
          this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}pageFamily`]
            .value,
      });
    }
    if (this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}subFamily`]) {
      changes.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW[
          `pv${page}subFamily`
        ].path,
        value:
          this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}subFamily`]
            .value,
      });
    }
    if (this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}pageAction`]) {
      changes.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW[
          `pv${page}pageAction`
        ].path,
        value:
          this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}pageAction`]
            .value,
      });
    }
    if (this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}pageid`]) {
      changes.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}pageid`]
          .path,
        value:
          this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}pageid`]
            .value,
      });
    }
    if (
      this.abreCuentasService.getDataTagg().PAGEVIEW[`pv${page}transactionName`]
    ) {
      changes.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW[
          `pv${page}transactionName`
        ].path,
        value:
          this.abreCuentasService.getDataTagg().PAGEVIEW[
            `pv${page}transactionName`
          ].value,
      });
    }
    if (
      this.abreCuentasService.getDataTagg().PAGEVIEW[
      `pv${page}transactionTransactionStep`
      ]
    ) {
      changes.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW[
          `pv${page}transactionTransactionStep`
        ].path,
        value:
          this.abreCuentasService.getDataTagg().PAGEVIEW[
            `pv${page}transactionTransactionStep`
          ].value,
      });
    }
    if (
      this.abreCuentasService.getDataTagg().PAGEVIEW[
      `pv${page}errorname`
      ]
    ) {
      changes.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW[
          `pv${page}errorname`
        ].path,
        value:
          this.abreCuentasService.getDataTagg().PAGEVIEW[
            `pv${page}errorname`
          ].value,
      });
    }
    this.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  tagg(page, pageEvent, modul, type, position, action) {
    const pagEvent = page ? `pv${page}E${pageEvent}` : `E${pageEvent}`;
    const event: TagEvent = {
      category: {
        module:
          this.abreCuentasService.getDataTagg().EVENT.customCategory.module[
          modul
          ],
        type: this.abreCuentasService.getDataTagg().EVENT.customCategory.type[
          type
        ],
        position:
          this.abreCuentasService.getDataTagg().EVENT.customCategory.position[
          position
          ],
      },
      action: this.abreCuentasService.getDataTagg().EVENT.customAction[action],
      label:
        this.abreCuentasService.getDataTagg().EVENT[
        page !== ''
          ? `pv${page}E${pageEvent}customLabel`
          : `E${pageEvent}customLabel`
        ],
    };
    let changes: Changes[] = [];
    if (
      this.abreCuentasService.getDataTagg().EVENT[
      `pv${page}E${pageEvent}setData`
      ][`pv${page}E${pageEvent}transactionName`]
    ) {
      changes.push({
        path: this.abreCuentasService.getDataTagg().EVENT[
          `pv${page}E${pageEvent}setData`
        ][`pv${page}E${pageEvent}transactionName`].path,
        value:
          this.abreCuentasService.getDataTagg().EVENT[
            `pv${page}E${pageEvent}setData`
          ][`pv${page}E${pageEvent}transactionName`].value,
      });
    }
    if (
      this.abreCuentasService.getDataTagg().EVENT[
      `pv${page}E${pageEvent}setData`
      ][`pv${page}E${pageEvent}transactionTransactionStep`]
    ) {
      changes.push({
        path: this.abreCuentasService.getDataTagg().EVENT[
          `pv${page}E${pageEvent}setData`
        ][`pv${page}E${pageEvent}transactionTransactionStep`].path,
        value:
          this.abreCuentasService.getDataTagg().EVENT[
            `pv${page}E${pageEvent}setData`
          ][`pv${page}E${pageEvent}transactionTransactionStep`].value,
      });
    }
    if (
      this.abreCuentasService.getDataTagg().EVENT[
      `pv${page}E${pageEvent}setData`
      ][`pv${page}E${pageEvent}clientElegibility`]
    ) {
      changes.push({
        path: this.abreCuentasService.getDataTagg().EVENT[
          `pv${page}E${pageEvent}setData`
        ][`pv${page}E${pageEvent}clientElegibility`].path,
        value:
          this.abreCuentasService.getDataTagg().EVENT[
            `pv${page}E${pageEvent}setData`
          ][`pv${page}E${pageEvent}clientElegibility`].value,
      });
    }
    if (
      this.abreCuentasService.getDataTagg().EVENT[
      `${pagEvent}setData`
      ][`${pagEvent}transactionProductDetails`]
    ) {
      changes.push({
        path: this.abreCuentasService.getDataTagg().EVENT[
          `${pagEvent}setData`
        ][`${pagEvent}transactionProductDetails`].path,
        value:
          this.abreCuentasService.getDataTagg().EVENT[
            `${pagEvent}setData`
          ][`${pagEvent}transactionProductDetails`].value,
      });
    }
    if (
      this.abreCuentasService.getDataTagg().EVENT[
      `pv${page}E${pageEvent}setData`
      ][`pv${page}E${pageEvent}transactionProductCategory`]
    ) {
      changes.push({
        path: this.abreCuentasService.getDataTagg().EVENT[
          `pv${page}E${pageEvent}setData`
        ][`pv${page}E${pageEvent}transactionProductCategory`].path,
        value:
          this.abreCuentasService.getDataTagg().EVENT[
            `pv${page}E${pageEvent}setData`
          ][`pv${page}E${pageEvent}transactionProductCategory`].value,
      });
    }

    this.pageTagEvent(event, changes);
  }

  /**
   * Función para enviar los datos a Google Analytics
   *
   * *Function to send data to Google Analytics*
   *
   * @param {TagEvent} event
   * @param {Changes[]} changes
   */
  pageTagEvent(event: TagEvent, changes?: Changes[]) {
    const newTrackEnventModelinterface: ITrackEventModel = {
      action: event.action,
      category: event.category,
      errorName: event.errorName,
      events: event.events,
      label: event.label,
      messageEvent: event.messageEvent,
      value: event.value,
    };
    console.log('DATAENVIAR-- ', changes);
    console.log('MODELO ', newTrackEnventModelinterface);
    console.log('DATATAGG ', this.abreCuentasService.getDataTagg());
    if (changes) {
      this.daliService.trackEvent(newTrackEnventModelinterface, changes);
    } else {
      this.daliService.trackEvent(newTrackEnventModelinterface);
    }
  }

  /**
   * Función para enviar los datos a Google Analytics
   *
   * *Function to send data to Google Analytics*
   *
   * @param {TagEvent} event
   * @param {Changes[]} changes
   */
  tagEvent(
    eventNumber: string,
    category: any,
    customAction: string,
    error?: string,
    customTagPageName?: any,
  ) {
    const tagPageName = customTagPageName ? customTagPageName : ''; // this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [];
      const transactionName =
        EVENT[
        `${tagPageName}E${eventNumber}setData`
        ][`${tagPageName}E${eventNumber}transactionName`];
      const detailProduct =
        EVENT[
        `${tagPageName}E${eventNumber}setData`
        ][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`];
      const transa =
        EVENT[
        `${tagPageName}E${eventNumber}setData`
        ][
        `${tagPageName}E${eventNumber}transactionDetailsTransactioninstitution`
        ];
      if (transactionName) {
        changes.push({
          path: transactionName.path,
          value: transactionName.value,
        });
      }
      if (detailProduct) {
        changes.push({
          path: detailProduct.path,
          value: detailProduct.value,
        });
      }
      if (transa) {
        changes.push({
          path: transa.path,
          value: transa.value,
        });
      }
      const event: TagEvent = {
        category: {
          module:
            EVENT.customCategory.module[
            category.module
            ],
          type: EVENT.customCategory.type[
            category.type
          ],
          position:
            EVENT.customCategory.position[
            category.position
            ],
        },
        action:
          EVENT.customAction[
          customAction
          ],
        label:
          EVENT[
          `${tagPageName}E${eventNumber}customLabel`
          ],
        errorName: error,
      };
      if (changes.length > 0) {
        this.daliService.trackEvent(event, changes);
      } else {
        this.daliService.trackEvent(event);
      }
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Obtiene el id del tag del producto
   *
   * *Gets tag id by product*
   *
   * @returns {string}
   */
  getTagIdByProduct(): string {
    const productSelected = this.abreCuentasService.getproductSelected(); // should existe after first page
    switch (productSelected.product_type) {
      case BUSINESS_CONST.PRODUCT_TYPE_TC:
        return this.tagsIdentifiers.tc;
      case BUSINESS_CONST.PRODUCT_TYPE_PAYROLL:
        return this.tagsIdentifiers.payroll;
      case BUSINESS_CONST.PRODUCT_TYPE_SAVINGS:
        return this.tagsIdentifiers.savingAccount;
      case BUSINESS_CONST.PRODUCT_TYPE_REVOLVING:
        return this.tagsIdentifiers.revolvingCredit;
      default:
        return '';
    }
  }

  /**
   * Establece el id del tag en la variable tagsIdentifier
   *
   * *Sets tag id in tagsIdentifier variable*
   *
   * @param {string} Tc
   * @param {string} payroll
   * @param {string} savingAccount
   * @param {string} revolvingCredit
   */
  setTagId(
    Tc: string,
    payroll: string,
    savingAccount: string,
    revolvingCredit: string,
  ) {
    this.tagsIdentifiers = new TagIdentifier(
      Tc,
      payroll,
      savingAccount,
      revolvingCredit,
    );
  }

  /**
   * Método get para la variable privada tagsIdentifier
   * solo para las pruebas unitarias
   *
   * *Get method for private tagsIdentifier variable*
   * *Just for unit tests*
   */
  getTagIdentifier = () => this.tagsIdentifiers;

  /**
   * Método set para la variable privada tagsIdentifier,
   * solo para las pruebas unitarias
   *
   * *Set method for private tagsIdentifier variable*
   * *Just for unit tests*
   */
  setTagIdentifier = (tagIdentifier: TagIdentifier) =>
    (this.tagsIdentifiers = tagIdentifier)

  pageTagEventOccupation(message: string, tagPageName?: string) {
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E10setData`][
            `${tagPageName}E10transactionName`
          ].path,
          value:
            EVENT[`${tagPageName}E10setData`][
              `${tagPageName}E10transactionName`
            ].value,
        },
        {
          path: EVENT[`${tagPageName}E10setData`][
            `${tagPageName}E10transactionDetailsProductcategory`
          ].path,
          value:
            EVENT[`${tagPageName}E10setData`][
              `${tagPageName}E10transactionDetailsProductcategory`
            ].value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.button,
          position: EVENT.customCategory.position.bottom,
        },
        action: EVENT.customAction.click,
        label: message,
      };

      this.pageTagEvent(event, changes);
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Crea el arreglo de cambios para el transactionProductCategory y el transactionName
   * @param tagPageName
   * @param tag_number
   * @returns changes array
   */
  createTagChanges(tagPageName: any, tag_number: string): Changes[] {
    return [
      {
        path: EVENT[
          `${tagPageName}E${tag_number}setData`
        ][`${tagPageName}E${tag_number}transactionDetailsProductcategory`].path,
        value:
          EVENT[
            `${tagPageName}E${tag_number}setData`
          ][`${tagPageName}E${tag_number}transactionDetailsProductcategory`]
            .value,
      },
      {
        path: EVENT[
          `${tagPageName}E${tag_number}setData`
        ][`${tagPageName}E${tag_number}transactionName`].path,
        value:
          EVENT[
            `${tagPageName}E${tag_number}setData`
          ][`${tagPageName}E${tag_number}transactionName`].value,
      },
    ];
  }

  addCommonPageChanges(changes: IPageLoadModel[]): void {
    const isApp =
      this.channelCommunicatorService.getChannelId().toString() === '141';
    const developmentTypeValue = isApp ? 'App' : 'Web';
    const siteChannelValue = isApp ? 'SuperAppPF' : 'HomeBankingPF';
    const permissionsValue = isApp
      ? this.abreCuentasService.getDevicePermissions()
      : 'NotAvailable';

    let commonChanges: IPageLoadModel[] = [];

    if (this.abreCuentasService.getDataTagg().PAGEVIEW.siteChannel) {
      commonChanges.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW.siteChannel
          .path,
        value: siteChannelValue,
      });
    }
    if (this.abreCuentasService.getDataTagg().PAGEVIEW.developmenttype) {
      commonChanges.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW.developmenttype
          .path,
        value: developmentTypeValue,
      });
    }
    if (this.abreCuentasService.getDataTagg().PAGEVIEW.environment) {
      commonChanges.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW.environment.path,
        value: this.parameterService.getParameter('daliEnvProd') ? 'Prod' : 'Dev',
      });
    }
    if (this.abreCuentasService.getDataTagg().PAGEVIEW.useragent) {
      commonChanges.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW.useragent.path,
        value: window.navigator.userAgent,
      });
    }
    if (this.abreCuentasService.getDataTagg().PAGEVIEW.permissions) {
      commonChanges.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW.permissions.path,
        value: permissionsValue,
      });
    }
    if (this.abreCuentasService.getDataTagg().PAGEVIEW.accessibility) {
      commonChanges.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW.accessibility.path,
        value: 'Off',
      });
    }
    if (PAGEVIEW['siteChannel' + developmentTypeValue]) {
      commonChanges.push({
        path: PAGEVIEW['siteChannel' + developmentTypeValue].path,
        value: PAGEVIEW['siteChannel' + developmentTypeValue].value,
      });
    }
    if (this.abreCuentasService.getDataTagg().PAGEVIEW.clientIdpf) {
      commonChanges.push({
        path: this.abreCuentasService.getDataTagg().PAGEVIEW.clientIdpf.path,
        value: this.bioCatchService.getUserPPID(),
      });
    }
    commonChanges.forEach(commonChange => changes.push(commonChange));
  }

  applyPascalCaseFormat(text: string): string {
    const str = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, _index) => word.toUpperCase())
      .replace(/\s+/g, '');
  }

  getProductFlow = () =>
    this.productsType[this.abreCuentasService.getProductsSelects()[0].product]

  isFirmlyAprovedMono = () =>
    this.firmlyApprovedService.isFirmlyApproved() &&
    this.abreCuentasService.getProductsSelects().length === 1

  sendTaggValues(value: string, page: string, position?: string, event?: string, extras?: any) {
    if ((this.channelCommunicatorService.getChannelId() === CHANNEL.SUPERAPP.CODE ||
      this.channelCommunicatorService.getChannelId() === CHANNEL.PORTALPN.CODE)
      && this.productsAccepted()) {
      try {
        const transactionName = this.transactionName(page, event);
        switch (value) {
          case 'init':
            if (Array.isArray(extras)) {
              for (const key in extras) {
                if (extras[key]['pageValue'] == null) {
                  this.abreCuentasService.setDataTagg('page', extras[key]['object'], page, '', extras[key]['value']);
                } else {
                  this.abreCuentasService.setDataTagg('page', 'pageid', page, '', extras[key]['pageValue']);
                }
              }
            } else {
              this.abreCuentasService.setDataTagg('page', 'pageid', page, '', extras.pageValue);
            }
            this.abreCuentasService.setDataTagg('page', 'transactionName', page, '', transactionName);
            this.pageLoadtagg(page);
            break;
          case 'next':
            if (extras && extras.object !== undefined) {
              this.abreCuentasService.setDataTagg('event', extras.object, page, event, extras.value);
            }
            this.abreCuentasService.setDataTagg('event', 'transactionName', page, event, transactionName);
            this.tagg(page, event, 'body', 'button', position, 'click');
            break;
          case 'header':
            this.abreCuentasService.setDataTagg('event', 'transactionName', page, event, transactionName);
            this.tagg(page, event, 'header', 'button', position, 'click');
            break;
          default:
            this.abreCuentasService.setDataTagg('event', 'transactionName', page, event, transactionName);
            this.tagg(page, event, 'body', 'button', position, 'click');
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
  transactionName(page: string, event?: string) {
    let transactionName = '';
    const product_type = this.abreCuentasService.getproductSelected().product_type;
    const pageEvent =
      page
      ? (event ? `pv${page}E${event}` : `pv${page}`)
      : `E${event}`;
    const dataTaggeo = this.abreCuentasService.getDataTagg().EVENT[`${pageEvent}setData`][`${pageEvent}transactionName`];
    if (dataTaggeo.value) {
      console.log('TransactionName traído.');
      const complement = this.abreCuentasService.getPostlogin() ? 'E' : 'N';
      transactionName = `${dataTaggeo.value}C${complement}`;
      console.log('TransactionName: ', transactionName);
    } else {
      // tslint:disable-next-line:no-multi-spaces
      if (product_type == BUSINESS_CONST.PRODUCT_TYPE_FREE) {
        transactionName = 'OfertaSoloCP';
      }
      if (product_type == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) {
        transactionName = 'OfertaSoloCR';
      }
      if (product_type == BUSINESS_CONST.PRODUCT_TYPE_TC) {
        transactionName = 'OfertaSoloTC';
      }
      console.log('TransactionName asignado');
    }
    return transactionName;
  }
  productsAccepted(): boolean {
    const product_type = this.abreCuentasService.getproductSelected().product_type;
    if ((product_type == BUSINESS_CONST.PRODUCT_TYPE_FREE ||
      product_type == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      product_type == BUSINESS_CONST.PRODUCT_TYPE_TC ||
      product_type === BUSINESS_CONST.MULTI)
      || (product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ||
        product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL)
      && !this.firmlyApprovedService.isFirmlyApproved()
    ) {
      return true;
    }
    return false;
  }

}
